import React from 'react'
import { withTheme } from 'theming'
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu'
import useTemplateHook from '../templateHook'
import CustomImage from '../../customImage/customImage'

const CategoryNavigatorSwimlane = ({ data = [], getStyleValue = () => {} }) => {
  const { KalingoLeftArrow, KalingoRightArrow } = useTemplateHook()

  function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext)
    return (
      <button
        className={`absolute left-0 z-10 bg-transparent px-0 hidden lg:flex justify-center ${
          !isFirstItemVisible ? 'opacity-100' : 'opacity-0'
        }`}
        disabled={isFirstItemVisible}
        onClick={() => scrollPrev()}
        title="Previous Item"
        style={{ width: '3.66032%', top: '25%' }}
      >
        <img src={KalingoLeftArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
      </button>
    )
  }

  function RightArrow() {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext)
    return (
      <button
        className={`absolute right-0 z-10 bg-transparent px-0 hidden lg:flex justify-center ${
          !isLastItemVisible ? 'opacity-100' : 'opacity-0'
        }`}
        disabled={isLastItemVisible}
        onClick={() => scrollNext()}
        title="Next Item"
        style={{ width: '3.66032%', top: '25%' }}
      >
        <img src={KalingoRightArrow} style={{ height: '37px' }} alt="KalingoRightArrow" />
      </button>
    )
  }

  return (
    <div
      style={{
        padding: '0px 3.66032%',
      }}
      className="w-full relative h-[90px] lg:h-[160px]"
    >
      <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow} wrapperClassName="w-full ">
        {data.length > 0 &&
          data.map((info, index) => (
            <Card
              key={index}
              itemId={`index${index}`}
              index={index}
              info={info}
              getStyleValue={getStyleValue}
            />
          ))}
      </ScrollMenu>
    </div>
  )
}

function Card({ index, info, getStyleValue }) {
  const { getTemplateImage, customNavigate } = useTemplateHook()
  const [isVisible, setIsVisible] = React.useState(false)

  React.useEffect(() => {
    setIsVisible(false)
    const timeoutId = window.setTimeout(() => setIsVisible(true), 600)
    return () => window.clearTimeout(timeoutId)
  }, [info?.id, info?.title, info?.thumbnail])

  const handleDetail = (item) => {
    if (item.content_type === 'IPTV') {
      customNavigate('DIRECT', `/channel/${item.id}`)
      return
    }
    if (item.content_type === 'CONTENT') {
      customNavigate('DIRECT', `/content/${item.id}`)
      return
    }
  }
  return (
    <div
      style={{
        color: getStyleValue('card_style', 'text_color', '#eaeaea'),
      }}
      key={index}
      className={`cursor-pointer w-[96.4px] h-[90px] lg:w-[183px] lg:h-[160px] transition-all duration-500 ease-in-out ${
        index && 'ml-2.5 lg:ml-6'
      } ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}`}
    >
      <CustomImage
        imageUrl={getTemplateImage(info.thumbnail)}
        imgClass={`w-full object-cover rounded xl:rounded-md cursor-pointer`}
        imgStyle={{ aspectRatio: '16/9' }}
        loaderClass={`w-full object-center rounded xl:rounded-md`}
        loaderStyle={{ aspectRatio: '16/9' }}
        imgAlt={info?.title}
        onClickRedirect={() => handleDetail(info)}
        // onClickRedirect={() => navigate(getLink())}
      />
      <p
        className="mb-0 mt-[3px] lg:mt-[6px] text-[10px] lg:text-[15px] font-semibold line-clamp-2 leading-tight cursor-pointer"
        onClick={() => handleDetail(info)}
      >
        {info.title}
      </p>
    </div>
  )
}

export default withTheme(CategoryNavigatorSwimlane)
